import React from 'react';
import { Home, Building2, Layers, Square, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { services } from '../data/mock';

const iconMap = {
  Home: Home,
  Building2: Building2,
  Layers: Layers,
  Square: Square,
};

const ServicesSection = () => {
  const scrollToContact = () => {
    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="servicii" className="py-24 bg-slate-50 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-grid-pattern opacity-50"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-6">
            Serviciile Noastre
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Soluții Complete de
            <span className="text-gradient"> Hidroizolații</span>
          </h2>
          <p className="text-lg text-slate-600">
            Oferim servicii profesionale de hidroizolație pentru toate tipurile de construcții, 
            de la case particulare la clădiri industriale.
          </p>
        </div>

        {/* Services grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon] || Home;
            return (
              <div
                key={service.id}
                className="group bg-white rounded-2xl p-6 shadow-lg shadow-slate-200/50 border border-slate-100 card-hover"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="text-white" size={30} />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-slate-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                {/* Features */}
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-sm text-slate-600">
                      <div className="w-1.5 h-1.5 rounded-full bg-cyan-500"></div>
                      {feature}
                    </li>
                  ))}
                </ul>

                {/* CTA */}
                <button
                  onClick={scrollToContact}
                  className="flex items-center gap-2 text-blue-600 font-semibold group-hover:text-cyan-600 transition-colors"
                >
                  Solicită ofertă
                  <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 p-8 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-3xl shadow-xl shadow-blue-500/25">
            <div className="text-white text-center sm:text-left">
              <h3 className="text-2xl font-bold mb-2">Ai nevoie de consultanță?</h3>
              <p className="text-blue-100">Contactează-ne pentru o evaluare gratuită</p>
            </div>
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-white text-blue-600 hover:bg-blue-50 px-8 py-6 rounded-full font-semibold whitespace-nowrap"
            >
              Contactează-ne acum
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
